import React from "react"

import styles from "./Diagram.module.scss"

export function Diagram({viewBox, children, className}) {
    return (
        <svg className={className ? `${styles.diagram} ${className}` : styles.diagram} viewBox={viewBox}
             aria-hidden="true">
            <defs>
                <marker id="architecture-arrowhead" markerWidth="8" markerHeight="8" refX="6" refY="4"
                        orient="auto">
                    <path d="M0,0 L8,4 L0,8 Z" className={styles.arrowhead}/>
                </marker>
            </defs>
            {children}
        </svg>
    )
}

export function Box({x, y, width, height, label, sublabel, accent}) {
    const midX = x + width / 2
    const midY = y + height / 2
    return (
        <g>
            <rect x={x} y={y} width={width} height={height} rx={6}
                  className={accent ? styles.boxAccent : styles.box}/>
            <text x={midX} y={sublabel ? midY - 6 : midY} textAnchor="middle" dominantBaseline="middle"
                  className={accent ? styles.boxLabelLight : styles.boxLabel}>{label}</text>
            {sublabel && (
                <text x={midX} y={midY + 12} textAnchor="middle" dominantBaseline="middle"
                      className={accent ? styles.boxSublabelLight : styles.boxSublabel}>{sublabel}</text>
            )}
        </g>
    )
}

export function Arrow({x1, y1, x2, y2, label, dashed, muted}) {
    const midX = (x1 + x2) / 2
    const midY = (y1 + y2) / 2
    return (
        <g>
            <line x1={x1} y1={y1} x2={x2} y2={y2} markerEnd="url(#architecture-arrowhead)"
                  className={muted ? styles.arrowMuted : styles.arrow}
                  strokeDasharray={dashed ? '5 4' : undefined}/>
            {label && <text x={midX} y={midY - 6} textAnchor="middle" className={styles.arrowLabel}>{label}</text>}
        </g>
    )
}

export function DiagramCaption({children}) {
    return <p className={styles.caption}>{children}</p>
}
